function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M440,32H40C17.92,32.026,0.026,49.92,0,72v160c0.026,22.08,17.92,39.974,40,40h400c22.08-0.026,39.974-17.92,40-40V72 C479.974,49.92,462.08,32.026,440,32z M56,48h368v24c0,13.255-10.745,24-24,24H80c-13.255,0-24-10.745-24-24V48z M424,256H56v-8 h368V256z M424,232H56v-8h368V232z M424,208H56v-8h368V208z M464,232c0,13.255-10.745,24-24,24v-64c0-4.418-3.582-8-8-8H48 c-4.418,0-8,3.582-8,8v64c-13.255,0-24-10.745-24-24V72c0-13.255,10.745-24,24-24v24c0.026,22.08,17.92,39.974,40,40h320 c22.08-0.026,39.974-17.92,40-40V48c13.255,0,24,10.745,24,24V232z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M264,160h-64c-4.418,0-8,3.582-8,8s3.582,8,8,8h64c4.418,0,8-3.582,8-8S268.418,160,264,160z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M408,128h-8c-4.418,0-8,3.582-8,8s3.582,8,8,8h8c4.418,0,8-3.582,8-8S412.418,128,408,128z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M440,128h-8c-4.418,0-8,3.582-8,8s3.582,8,8,8h8c4.418,0,8-3.582,8-8S444.418,128,440,128z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M256,296c0-4.418-3.582-8-8-8s-8,3.582-8,8c0.145,7.097-2.211,14.018-6.656,19.552 c-12.458,16.911-12.458,39.961,0,56.872c8.873,11.536,8.873,27.599,0,39.136c-6.202,8.171-9.491,18.183-9.344,28.44 c0,4.418,3.582,8,8,8s8-3.582,8-8c-0.146-7.102,2.21-14.029,6.656-19.568c12.447-16.92,12.447-39.968,0-56.888 c-8.873-11.53-8.873-27.59,0-39.12C252.858,316.259,256.147,306.252,256,296z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M192,296c0-4.418-3.582-8-8-8s-8,3.582-8,8c0.145,7.097-2.211,14.018-6.656,19.552 c-12.458,16.911-12.458,39.961,0,56.872c8.873,11.536,8.873,27.599,0,39.136c-6.202,8.171-9.491,18.183-9.344,28.44 c0,4.418,3.582,8,8,8s8-3.582,8-8c-0.146-7.102,2.21-14.029,6.656-19.568c12.447-16.92,12.447-39.968,0-56.888 c-8.873-11.53-8.873-27.59,0-39.12C188.858,316.259,192.147,306.252,192,296z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M320,296c0-4.418-3.582-8-8-8s-8,3.582-8,8c0.145,7.097-2.211,14.018-6.656,19.552 c-12.458,16.911-12.458,39.961,0,56.872c8.873,11.536,8.873,27.599,0,39.136c-6.202,8.171-9.491,18.183-9.344,28.44 c0,4.418,3.582,8,8,8s8-3.582,8-8c-0.146-7.102,2.21-14.029,6.656-19.568c12.447-16.92,12.447-39.968,0-56.888 c-8.873-11.53-8.873-27.59,0-39.12C316.858,316.259,320.147,306.252,320,296z"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function SvgAirConditioner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirConditioner);
export default __webpack_public_path__ + "static/media/air-conditioner.ba920d90.svg";
export { ForwardRef as ReactComponent };